import VanillaTilt from "vanilla-tilt";

export default function tiltEffect() {
    const elements = document.querySelectorAll(".js-tilt");
    VanillaTilt.init(elements);
}
